import { IotError } from "@iot-platform/core";
import { t } from "i18next";

export class NoLoggedUserError extends IotError {
    constructor() {
        super(t("error:authentication.logout.noLoggedUserError"));

        Object.setPrototypeOf(this, NoLoggedUserError.prototype);
    }
}
